import React, { PropTypes } from 'react';
import DataService from '../../lib/DataService';
import SharedTools from '../../lib/SharedTools';
import { Button, Collapse, Icon, message, Modal, Radio, Select } from 'antd';
import { hashHistory } from 'react-router';

const Panel = Collapse.Panel;
const RadioGroup = Radio.Group;
const Option = Select.Option;

export default class ObservationRecordPage extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    // set state
    let path = props.location.pathname;
    let currentSemester = SharedTools.getCurrentSemester(),
        semesters = SharedTools.getAllSemesters(currentSemester, 20201),
        semester = props.location.query.semester ? props.location.query.semester : currentSemester,
        semesterToString = '';
    
    semesterToString = semesters.find(item => item.semester == semester).semesterToString;

    
    this.state = {
      type: path.indexOf('class-evaluation') >= 0 ? 'evaluate' : 'observe',
      semester,
      semesters,
      semesterToString,
      recordId: props.params.observationId ? props.params.observationId : 0,
      studentIds: props.params.studentId ? props.params.studentId.split(',') : [0],
      finalEvaluation: props.location.query.finalEvaluation == 'true' ? true : false,
      classId: props.params.classId ? props.params.classId : 0,
      criterion: [],
      activeKey: [],
      levels: [],
      selectedPointLevels: [],   
      answer: undefined,
      answerId: 0,
      showModal: false,
      
    };
    // bind this
    this.onChangeCollapse = this.onChangeCollapse.bind(this)
    this.chooseLevel = this.chooseLevel.bind(this)
    this.changeLevels = this.changeLevels.bind(this)
    this.showLevelCase = this.showLevelCase.bind(this)
    this.submit = this.submit.bind(this)
  }

  componentDidMount() {
    this.getEvaluationCategories()
    this.getOneStudentInfo()
  }


  getOneStudentInfo() {
    DataService.getOneStudentInfo(this.state.studentIds[0]).then((res) => {
      this.setState({ student: res });
    }).catch((error) => {
      console.log(error);
    });
  }

  // 获取评价类别
  getEvaluationCategories() {
    let semester = this.state.semester
    DataService.getClassById(this.state.classId).then((res) => {
      let class_grade_id = res.class_grade_id;
      this.setState(
        {
          class_name:res.name
        }
      )
      DataService.getEvaluationCategories({ class_grade_id,semester }).then((res) => {
        if (this.state.finalEvaluation) {
          this.getEvaluationInfo()
        }
        this.setState({
          criterion: res,
          activeKey: res.map(item => String(item.id))
        })
        this.setState({ criterion: res });
      }).catch((error) => {
        console.log(error);
      });
    }).catch((error) => {
      console.log(error);
    });
    
  }

  // 获取评价内容
  getEvaluationInfo() {
    let { studentIds, type, recordId } = this.state;
    if(studentIds.length===1){
      let data = {
        student_id: studentIds[0],
      }
      type == 'observe' ? data.observation_id = recordId : data.evaluation_instance_id = recordId;
      DataService.getEvaluationInfo(data).then((res) => {
        let selectedPointLevels = res.evaluation_levels.map(item => {
          return { levelId: item.evaluation_category_id, answer: item.id }
        })
        this.setState({
          selectedPointLevels,
          answerId: res.id
        })
        this.toolCriterion(selectedPointLevels)
      }).catch((error) => {
        console.log(error);
      });
    }
  }

  // 展开折叠面板
  onChangeCollapse(key) {
    this.setState({
      activeKey: key
    })
  }

  // 选择评价
  chooseLevel(category_id, title) {
    DataService.getEvaluationLevel({ category_id }).then((res) => {
      let { selectedPointLevels } = this.state;
      let item = selectedPointLevels.find(item => item.levelId == category_id);
      this.setState({
        levels: res,
        levelId: category_id,
        answer: item ? String(item.answer) : undefined,
        categoryTitle: title
      })
    }).catch((error) => {
      console.log(error);
    });
  }

  changeLevels(e) {
    let { selectedPointLevels } = this.state;
    let item = selectedPointLevels.find(item => item.levelId == this.state.levelId);
    item ? (item.answer = e.target.value) : selectedPointLevels.push({
                                                                        levelId: this.state.levelId,
                                                                        answer: e.target.value 
                                                                      });
    this.setState({
      selectedPointLevels,
      answer: e.target.value
    })

    this.toolCriterion(selectedPointLevels)
  }

  showLevelCase(e, level) {
    e.stopPropagation();
    DataService.getCase({ id: level.id }).then((res) => {
      this.setState({
        levelCase: res,
        showModal: true,
        showLevel: level
      })
    }).catch((error) => {
      console.log(error);
    });

  }

  // 更新目录
  toolCriterion(selectedPointLevels) {
    let {criterion} = this.state;
    const selectedPointIds = selectedPointLevels.map(item => item.levelId);

    criterion = criterion.map(item => {
      return {
        ...item,
        selectedCount: item.child_categories.filter(p => selectedPointIds.includes(p.id)).length,
        child_categories: item.child_categories.map(p => {
          return {
            ...p,
            selected: selectedPointIds.includes(p.id),
          }
        })
      }

    })

    this.setState({
      criterion
    })
  }

  // 提交
  submit() {
    const { answerId, selectedPointLevels,studentIds } = this.state;
    const selectedPointIds = selectedPointLevels.map(item => item.answer);

    if (selectedPointIds.length <= 0) {
      message.info('请先进行评价')
      return
    }

    if(studentIds.length===1){
      answerId ? this.updateEvaluate() : this.createEvaluate();
    }
    else{
      this.createAndUpdateEvaluate()
    }

  }

  // 更新APi
  updateEvaluate() {
    const { answerId, selectedPointLevels } = this.state;
    const selectedPointIds = selectedPointLevels.map(item => item.answer);

    let data = {
      level_ids: selectedPointIds,
      id: answerId
    }
    DataService.updateEvaluate(data).then((res) => {
      message.success('提交成功')
      setTimeout(function () { hashHistory.goBack(); }, 1000)
    }).catch((error) => {
      console.log(error);
    });
  }

  // 创建APi
  createEvaluate() {
    const { type, studentIds, classId, recordId, selectedPointLevels } = this.state;
    const selectedPointIds = selectedPointLevels.map(item => item.answer);

    let data = {
      level_ids: selectedPointIds,
      class_record_id: classId,
      student_id: studentIds[0]
    }
    if (type == 'evaluate') {
      data.evaluation_instance_id = recordId;
    } else {
      data.observation_id = recordId;
    }

    DataService.createEvaluate(data).then((res) => {
      message.success('提交成功')
      setTimeout(function () { hashHistory.goBack(); }, 1000)
    }).catch((error) => {
      console.log(error);
    });
  }

  createAndUpdateEvaluate(){
    const { type, studentIds, classId, recordId, selectedPointLevels } = this.state;
    const selectedPointIds = selectedPointLevels.map(item => item.answer);
    let data = {
      level_ids: selectedPointIds,
      class_record_id: classId,
      student_ids: studentIds
    }
    if (type == 'evaluate') {
      data.evaluation_instance_id = recordId;
    } else {
      data.observation_id = recordId;
    }

    DataService.createAndUpdateEvaluate(data).then((res) => {
      message.success('提交成功')
      setTimeout(function () { hashHistory.goBack(); }, 1000)
    }).catch((error) => {
      console.log(error);
    });
  }
  render() {
    return (
      <div className="observation-record-page">
        <div className="page-header">
          <h4>
            当前学期：{this.state.semesterToString}
          </h4>
          <h4>
            当前学生：{this.state.studentIds.length==1&&this.state.student ? this.state.student.full_name : (this.state.class_name?this.state.class_name : '')+'全班'}
          </h4>
        </div>
        <div className="evaluation-container">
          <EvaluationCategoriesView 
            criterion={this.state.criterion}
            activeKey={this.state.activeKey}
            levelId={this.state.levelId}
            selectedPointLevels={this.state.selectedPointLevels}
            onChangeCollapse={this.onChangeCollapse}
            chooseLevel={this.chooseLevel}
          />
          {this.state.levelId ? <EvaluationLevelsView 
            categoryTitle={this.state.categoryTitle}
            levels={this.state.levels}
            answer={this.state.answer}
            changeLevels={this.changeLevels}
            showLevelCase={this.showLevelCase}
          /> : <div className="blank-view"></div>}
        </div>
        <LevelCaseModal level={this.state.showLevel} levelCase={this.state.levelCase} showModal={this.state.showModal} onCancelModal={() => this.setState({ showModal: false })}/>
        <Button className="submit-btn" size='large' type="primary" onClick={this.submit}>确认提交</Button>

        {this.state.criterion && this.state.criterion.length > 0 && this.state.type == 'evaluate' && this.state.studentIds.length===1 && <HistoryEvaluations criterion={this.state.criterion} studentId={this.state.studentIds[0]}/>}
      </div>
    )
  }
}

/*
  * 评价目录
*/
const EvaluationCategoriesView = ({ criterion = [], activeKey = [], levelId = undefined ,selectedPointLevels = [], onChangeCollapse, chooseLevel}) => {
  const toolSelectedLevel = (levelId, selectedPointLevels) => {
    let item = selectedPointLevels.find(item => item.levelId == levelId);
    return item ? true : false
  }

  return (
    <Collapse activeKey={activeKey} onChange={(e) => onChangeCollapse(e)} className="evaluation-collapse">
      {criterion.map(item => <Panel header={<div>
                                              <span>{item.title}</span>
                                              {item.selectedCount ? <span style={{float:'right', marginRight: '20px'}}>{item.selectedCount}项</span> : ''}
                                            </div>} 
                                            key={String(item.id)
                                          }>
            {item.child_categories.map((level, index) => <p key={level.id} 
              onClick={() => chooseLevel(level.id, level.title)}
              className={level.id == levelId ? 'selected' : ''}
            >
              {toolSelectedLevel(level.id, selectedPointLevels) ? <Icon type="check" style={{ marginRight: '10px', color: '#4DA1FF' }} /> :
                                                                  <div className="blank-icon"></div> 
              }
              {index + 1}.{level.title}
            </p>
          )}
        </Panel>
      )}
    </Collapse>
  )
}

/*
  * 评价内容
*/
const EvaluationLevelsView = ({ categoryTitle, levels, answer, changeLevels, showLevelCase }) => {
  return (
    <div className="evaluation-levels-card">
      <div className="title">{categoryTitle}</div>
      <RadioGroup
        value={answer}
        onChange={(e) => {
          changeLevels(e)
        }}
      >
        {levels.map(item => <div className="radio-box" key={item.id}>
                              <Radio value={String(item.id)} >
                              {item.title}
                              </Radio>
                              {item.description ? <div className="level-label">
                                {item.description}
                                {item.detail ? <span className="more" onClick={(e) => showLevelCase(e, item)}>
                                                  更多<Icon type="right"/>
                                                </span> : ''}
                              </div> : ''}
        </div>)}
      </RadioGroup>
    </div>
  )
}

/*
  * Modal
*/
const LevelCaseModal = ({ level = {}, levelCase = {}, showModal = false, onCancelModal}) => {
  return (
    <Modal
      title={level.title}
      visible={showModal}
      cancelText={false}
      footer={null}
      onCancel={() => {
        onCancelModal()
      }}
      wrapClassName="story-modal"
    >
      <div>{level.title + '-' + level.description}</div>
      <div>{level.detail}</div>
      {levelCase && levelCase.segments_info && levelCase.segments_info.length > 0 ? <div>经典案例</div> : '' }
      {levelCase && levelCase.segments_info && levelCase.segments_info.length > 0 ? levelCase.segments_info.map(item => <div key={item.id}>
        <img src={item.image_url} alt=""/>
        <p>{item.text}</p>
      </div>) : ''}
    </Modal>
  )
}

/*
  查看历史评价
*/ 
class HistoryEvaluations extends React.Component {
  constructor(props) {
    super(props);
    // 学期列表
    let currentSemester = SharedTools.getCurrentSemester();
    let semester = SharedTools.getPreviousSemester(currentSemester);
    let semesters = SharedTools.getAllSemesters(currentSemester, 20201);

    // set state
    this.state = {
      activeKey: [],
      semesters,
      semester,
      showStatus: false,
      criterion: [],
      levelId: 0
    };

    this.onChangeCollapse = this.onChangeCollapse.bind(this)
    this.chooseLevel = this.chooseLevel.bind(this)

  }

  componentDidMount() {
    // this.getEvaluationInfo()
  }

  // 获取评价内容
  getEvaluationInfo() {
    let data = {
      student_id: this.props.studentId,
      semester: this.state.semester
    }
    DataService.getEvaluationInfo(data).then((res) => {
      let selectedPointLevels = res.evaluation_levels.map(item => {
        return { levelId: item.evaluation_category_id, answer: item.title }
      })
      this.toolCriterion(selectedPointLevels)
    }).catch((error) => {
      if (error && error.errorMessage && error.errorMessage.errors[0].code == 43) {
        message.error('该学期暂时没有评价')
        this.toolCriterion([])
        return
      }
      message.error('数据获取错误')
      this.toolCriterion([])
    });
  }

  showHistoryStatus() {
    if (!this.state.showStatus) {
      this.getEvaluationInfo()
    }
    this.setState({ 
      showStatus: !this.state.showStatus
    })
  }

  // 更新目录
  toolCriterion(selectedPointLevels) {
    let { criterion } = this.props;
    const selectedPointIds = selectedPointLevels.map(item => item.levelId);

    if (criterion) {
      criterion = criterion.map(item => {
        return {
          ...item,
          selectedCount: item.child_categories.filter(p => selectedPointIds.includes(p.id)).length,
          child_categories: item.child_categories.map(p => {
            return {
              ...p,
              anwser: selectedPointLevels.find(item => item.levelId == p.id) ? selectedPointLevels.find(item => item.levelId == p.id).answer : '无',
            }
          })
        }

      })
    }

    this.setState({
      criterion
    })
  }

  // 展开折叠面板
  onChangeCollapse(key) {
    this.setState({
      activeKey: key
    })
  }

  selectSemester(value) {
    if (value != this.state.semester) {
      this.setState({
        semester: value,
      }, () => {
        this.getEvaluationInfo()
      })
    }
  }

  // 选择评价
  chooseLevel(category_id, title) {
    this.setState({
      levelId: category_id,
    })
  }


  _selectSemesterBox() {
    let style = {
      margin: '10px 20px',
      display: 'inline-block'
    }
    return (
      <div className="select-semester-box" style={style}>
        <Select value={String(this.state.semester)} style={{ width: 145 }} onChange={this.selectSemester.bind(this)}>
          {this.state.semesters.map((semester, index) => <Option value={String(semester.semester)} key={index}>{semester.semesterToString}</Option>)}
        </Select>
      </div>
    )
  }

  render() {
    return (
      <div className="history-evaluations-view">
        <div className={"show-collapse-item" + (this.state.showStatus ? ' show' : '')} onClick={this.showHistoryStatus.bind(this)}>
          {!this.state.showStatus ? '查看历史评价' : <Icon type="close" />}
        </div>:
        {this.state.showStatus ? <div className="history-evaluations-categories">
          <div className="view-header">
            历史评价
            {this._selectSemesterBox()}
          </div>
          <HistoryEvaluationCategoriesView
            criterion={this.state.criterion}
            activeKey={this.state.activeKey}
            levelId={this.state.levelId}
            onChangeCollapse={this.onChangeCollapse}
            chooseLevel={this.chooseLevel}
          />
        </div> : ''}
      </div>
    )
  }
}

/*
  * 历史评价目录
*/
const HistoryEvaluationCategoriesView = ({ criterion = [], activeKey = [], levelId = undefined, selectedPointLevels = [], onChangeCollapse, chooseLevel }) => {

  return (
    <Collapse activeKey={activeKey} onChange={(e) => onChangeCollapse(e)} className="evaluation-collapse">
      {criterion.map(item => <Panel header={<div>
        <span>{item.title}</span>
        {item.selectedCount ? <span style={{ float: 'right', marginRight: '20px' }}>{item.selectedCount}项</span> : ''}
      </div>}
        key={String(item.id)
        }>
        {item.child_categories.map((level, index) => <p key={level.id}
          onClick={() => chooseLevel(level.id, level.title)}
          className={"answer-label" + (level.id == levelId ? ' selected' : '')}
        >
          <span>{index + 1}.{level.title}</span>
          <span>{level.anwser}</span>
        </p>
        )}
      </Panel>
      )}
    </Collapse>
  )
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/development/ObservationRecordPage.jsx